module.exports = __webpack_public_path__ + "static/matbuu-web-f5a9df9733f0e6fe719e7d1e6bc485f3.jpg";